import React from 'react';
import { Text, View, ScrollView } from 'react-native';

import { globalStyles } from 'Theme';
import { t } from 'Locale';
import Hr from 'LocalGluons/components/Hr';
import Icon from 'LocalGluons/components/Icon';
import { Device, getActualHeight } from 'DeviceUtils';

import Button from 'LocalGluons/components/Button';
import defaultStyles from './RecordingsNotAvailable.jss';

const RecordingsNotAvailable = ({ onConfirm, confirmLabel, mode }) => {
    const isLandscape = mode === 'landscape' && !Device.isPhone;
    return (
        <View
            style={[
                defaultStyles.container,
                Device.isTabletOrWeb ? { height: getActualHeight() * 0.675 } : {}
            ]}
        >
            <ScrollView contentContainerStyle={defaultStyles.scrollViewContainer}>
                <View style={defaultStyles.innerContainer}>
                    <View style={defaultStyles.titleContainer}>
                        <Icon style={defaultStyles.icon} name="warning_yellow_black" />
                        <Text style={globalStyles.title}>
                            {t('COMMON.RECORDINGS_INACTIVE_TITLE')}
                        </Text>
                    </View>
                    <Hr style={defaultStyles.hr} />
                    <Text style={globalStyles.secondaryDescription}>
                        {t('COMMON.RECORDINGS_INACTIVE_DESCRIPTION___PACKAGE.BENEFIT')}
                    </Text>
                    <View
                        style={[
                            defaultStyles.buttonsContainer,
                            defaultStyles.buttonContainerOneButton,
                            isLandscape && defaultStyles.landscapeButtonsContainer
                        ]}
                    >
                        {confirmLabel && (
                            <Button
                                style={{ button: defaultStyles.containerItem }}
                                title={confirmLabel}
                                onPress={onConfirm}
                                testID="confirm_button"
                            />
                        )}
                    </View>
                </View>
            </ScrollView>
        </View>
    );
};

export default RecordingsNotAvailable;
